import React, { SVGProps } from 'react';

export const LeaderBoardIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 18,
  height = 18,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 18 18"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 0H15C13.8954 0 13 0.89543 13 2V16C13 17.1046 13.8954 18 15 18H16C17.1046 18 18 17.1046 18 16V2C18 0.89543 17.1046 0 16 0Z"
        fill="currentColor"
      />
      <path
        d="M9.5 6H8.5C7.39543 6 6.5 6.89543 6.5 8V16C6.5 17.1046 7.39543 18 8.5 18H9.5C10.6046 18 11.5 17.1046 11.5 16V8C11.5 6.89543 10.6046 6 9.5 6Z"
        fill="currentColor"
      />
      <path
        d="M3 13H2C0.89543 13 0 13.8954 0 15V16C0 17.1046 0.89543 18 2 18H3C4.10457 18 5 17.1046 5 16V15C5 13.8954 4.10457 13 3 13Z"
        fill="currentColor"
      />
    </svg>
  );
};
